export var toFlatErrors = function (errors, setErrors) {
    Object.keys(errors).forEach(function (namePart) {
        var v = errors[namePart];
        if (Array.isArray(v) && typeof v[0] === 'string') {
            setErrors(namePart, v);
        }
        else {
            var newObj = Object.entries(v).reduce(function (r, _a) {
                var name = _a[0], value = _a[1];
                r[namePart + "." + name] = value;
                return r;
            }, {});
            toFlatErrors(newObj, setErrors);
        }
    });
};
